import { render, staticRenderFns } from "./life-bar.vue?vue&type=template&id=e8ad9e30&"
import script from "./life-bar.vue?vue&type=script&lang=js&"
export * from "./life-bar.vue?vue&type=script&lang=js&"
import style0 from "./life-bar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports